import React, { useEffect, useState } from "react";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UserCircle2, Car, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const freelancerIcon = L.divIcon({
  className: "",
  html: '<div style="width:34px;height:34px;border-radius:50%;background:#3b82f6;box-shadow:0 4px 12px rgba(59,130,246,0.5);display:flex;align-items:center;justify-content:center;border:3px solid white"><svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/></svg></div>',
});
const driverIcon = L.divIcon({
  className: "",
  html: '<div style="width:34px;height:34px;border-radius:50%;background:#f97316;box-shadow:0 4px 12px rgba(249,115,22,0.5);display:flex;align-items:center;justify-content:center;border:3px solid white"><svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18.9 6.5c-.2-.6-.8-1-1.4-1H6.5c-.7 0-1.2.4-1.4 1L3 12v8c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1h12v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-8l-2.1-5.5zM6.5 16c-.8 0-1.5-.7-1.5-1.5S5.7 13 6.5 13s1.5.7 1.5 1.5S7.3 16 6.5 16zm11 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"/></svg></div>',
});

export default function LiveMap() {
  const [data, setData] = useState({ freelancers: [], drivers: [] });

  const load = async () => {
    try {
      const r = await axios.get(`${API}/map/live`);
      setData(r.data);
    } catch (err) {
      console.error("[LiveMap] load failed", err);
    }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  const center = [-23.55, -46.63];

  return (
    <div className="max-w-6xl mx-auto space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight" data-testid="livemap-heading">Mapa ao vivo</h1>
          <p className="text-muted-foreground mt-1 text-sm">Freelancers e motoristas online agora mesmo</p>
        </div>
        <div className="flex gap-2">
          <Badge className="bg-blue-500 gap-1"><UserCircle2 className="w-3 h-3" />{data.freelancers.length} freelancers</Badge>
          <Badge className="bg-orange-500 gap-1"><Car className="w-3 h-3" />{data.drivers.length} motoristas</Badge>
        </div>
      </div>

      <Card className="overflow-hidden" data-testid="livemap-container">
        <div className="h-[600px] w-full">
          <MapContainer center={center} zoom={12} style={{ height: "100%", width: "100%" }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OSM" />
            {data.freelancers.map(f => (
              <Marker key={"fl-" + f.user_id} position={[f.lat, f.lng]} icon={freelancerIcon}>
                <Popup>
                  <div className="text-sm">
                    <strong>{f.name}</strong><br/>
                    {f.headline}<br/>
                    <span className="text-xs text-muted-foreground"><MapPin className="w-3 h-3 inline" /> {f.city}</span>
                  </div>
                </Popup>
              </Marker>
            ))}
            {data.drivers.map(d => (
              <Marker key={"dr-" + d.user_id} position={[d.lat, d.lng]} icon={driverIcon}>
                <Popup>
                  <div className="text-sm">
                    <strong>{d.name}</strong><br/>
                    Motorista {d.vehicle_type === "moto" ? "moto" : "carro"}
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </Card>
    </div>
  );
}
